import EditIcon from '@mui/icons-material/Edit';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, TableCell, TableRow } from '@mui/material';
import prettyMilliseconds from 'pretty-ms';
import React from 'react';

export const PatchNoteRow = ({ data, onEdit }) => {
  const start = new Date(data.startAt);
  const end = new Date(data.endAt);

  return (
    <TableRow>
      {/*Titre*/}
      <TableCell sx={{ border: 1 }} align="center">
        <Button
          size="small"
          variant="outlined"
          onClick={() =>
            window.open(data.link, '_blank', 'noopener,noreferrer')
          }
          color="primary"
          sx={{ p: 1, minWidth: '60%', justifyContent: 'space-evenly' }}
          endIcon={<OpenInNewIcon />}
        >
          {data.releaseNumber}
        </Button>
      </TableCell>
      {/*Responsable*/}
      <TableCell sx={{ border: 1 }} align="center">
        {data.author.firstName} {data.author.lastName}
      </TableCell>
      {/*Début - Fin */}
      <TableCell sx={{ border: 1 }} align="center">
        {start.toLocaleString('fr-FR')} - {end.toLocaleTimeString('fr-FR')}
      </TableCell>
      {/*Durée */}
      <TableCell sx={{ border: 1 }} align="center">
        {prettyMilliseconds(end - start)}
      </TableCell>
      {/*Edit */}
      <TableCell sx={{ border: 1 }} align="center">
        <Button onClick={onEdit}>
          <EditIcon />
        </Button>
      </TableCell>
    </TableRow>
  );
};
